/* eslint-disable */
import React from "react";
import "./index.css";

import CheckIcon from "../../../../static/icon/checkIcon.svg";
import dropdownOutline from "../../../../static/icon/dropdownOutline.svg";
import lightDropdownOutline from "../../../../static/light-icon/dropdownOutline.svg";

import { Image, Dropdown } from "react-bootstrap";
import { TASK_TYPE, TaskType } from "../../../../config";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../../../providers/CustomThemeProvider";

interface IProps {
	taskType: any;
	onClickItem: (item: any) => void;
}

let typeMap = [
	// TASK_TYPE.LANGUAGE_SAFETY,
	TASK_TYPE.QUERY_DATA,
	// TASK_TYPE.CHECK_LABEL,
	// TASK_TYPE.LOW_QUALITY_DETECTION,
];

// if (process.env.REACT_APP_ENV === "production") {
// 	typeMap = [TASK_TYPE.LANGUAGE_SAFETY, TASK_TYPE.QUERY_DATA];
// }

function ModelDropdown(props: IProps) {
	const { taskType, onClickItem } = props;
	const { t, i18n } = useTranslation();
	const { isDarkMode, switchTheme } = useTheme();

	const handleClickModel = (modelItem: any) => {
		onClickItem(modelItem);
	};

	return (
		<>
			<Dropdown id="dropdown-basic-button">
				<Dropdown.Toggle id="dropdown-autoclose-true">
					<div className="docta-ai-model-choose-title">
						<div className="docta-ai-model-choose-title-left">
							<div className="docta-ai-model-choose-title-text">
								{i18n.language == "en" ? taskType?.title : taskType?.cnTitle}
							</div>
						</div>
						<Image
							src={isDarkMode ? dropdownOutline : lightDropdownOutline}
							className="docta-ai-user-dropdown-item-icon"
						/>
					</div>
				</Dropdown.Toggle>

				<Dropdown.Menu className="docta-ai-user-dropdown">
					<div className="docta-ai-user-dropdown-title"> MODEL </div>

					{typeMap?.map((modelItem) => {
						return (
							<Dropdown.Item
								key={modelItem.type}
								onClick={() => {
									handleClickModel(modelItem);
								}}
							>
								<div className="docta-ai-user-dropdown-item">
									<Image
										src={isDarkMode ? modelItem.icon : modelItem.lightIcon}
										className="docta-ai-user-dropdown-item-icon"
									/>
									<div className="docta-ai-user-dropdown-item-text">
										<div className="user-dropdown-item-text-title">
											{i18n.language == "en"
												? modelItem.title
												: modelItem.cnTitle}
										</div>
										{modelItem.subtitle && (
											<div className="user-dropdown-item-text-subtitle">
												{i18n.language == "en"
													? modelItem.subtitle
													: modelItem.cnsubtitle}
											</div>
										)}
									</div>
									{taskType === modelItem && (
										<div>
											<Image src={CheckIcon} className="docta-ai-checkicon" />
										</div>
									)}
								</div>
							</Dropdown.Item>
						);
					})}
				</Dropdown.Menu>
			</Dropdown>
		</>
	);
}

export default ModelDropdown;
